export default __webpack_public_path__ + "./fonts/otp.08f72668949c216ce458b60b77617b67.svg";